
import { getApiUserUserInfo } from '@/shared/apis/fastmile/generated/user/user'
import { createAsyncThunk } from '@reduxjs/toolkit'

export const fetchUserInfo = createAsyncThunk('user/fetchUserInfo', async (_) => {
  const userInfo = await getApiUserUserInfo()

  return userInfo
})